(function () {
    'use strict';

    angular
        .module('bcmModule')
        .controller('biaResponsibilityFullImpactsRatingsController', Controller);

    Controller.$inject = ['$scope', '$state', 'notificationService', 'biaResponsibilityService'];

    function Controller($scope, $state, notificationService, biaResponsibilityService) {

        /**
         * @property $scope.boxContext.BIAResponsibilityImpactLevels {LookupAttributeValue[]}
         */

        if (_.isUndefined($scope.ctrlCtxt)) $scope.ctrlCtxt = {};

        init();

        // Set HasFinancialImpact
        $scope.setHasFinancialImpact = function (valueToSet) {
            $scope.boxModel.HasFinancialImpact = valueToSet;

            if (!valueToSet) {
                $scope.boxModel.FinancialImpactDetails = null;
            }

            impactChanged();
        };

        // Set HasOperationalImpact
        $scope.setHasOperationalImpact = function (valueToSet) {
            $scope.boxModel.HasOperationalImpact = valueToSet;

            if (!valueToSet) {
                $scope.boxModel.OperationalImpactDetails = null;
            }

            impactChanged();
        };

        // Set HasComplianceImpact
        $scope.setHasComplianceImpact = function (valueToSet) {
            $scope.boxModel.HasComplianceImpact = valueToSet;

            if (!valueToSet) {
                $scope.boxModel.ComplianceImpactDetails = null;
            }

            impactChanged();
        };

        // Override OverallImpactLevel
        $scope.overrideOverallImpactLevel = function (levelToSet) {

            if (levelToSet) {
                $scope.ctrlCtxt.overallImpactToDisplay = levelToSet.Order;
                $scope.boxModel.OverallImpactLevel = levelToSet;
            }

            $scope.boxModel.OverallImpactLevel =
                $scope.boxContext.BIAResponsibilityImpactLevels[$scope.ctrlCtxt.overallImpactToDisplay];
            $scope.boxModel.OverallImpactLevelID = $scope.boxModel.OverallImpactLevel.LookupAttributeValueID;
        };

        // Save Changes
        $scope.saveChanges = function (form) {
            if (form.$invalid) return;

            return biaResponsibilityService
                .updateBIAResponsibility(
                    $scope.boxContext.BIAProfile.BIAProfileID,
                    $scope.boxModel.BIAResponsibilityID,
                    $scope.boxModel)
                .then(function () {
                    notificationService.notify('Disruption Impacts Saved Successfully');
                    $state.go('^', {}, {reload: true});
                });
        };

        function impactChanged() {
            biaResponsibilityService
                .getBIAResponsibilityComputedImpactLevel(
                    $scope.boxContext.BIAProfile.BIAProfileID,
                    $scope.boxModel)
                .then(function (impact) {
                    $scope.boxModel.OverallImpactLevelID = impact.ComputedImpactLevelID;
                    $scope.boxModel.OverallImpactLevel = impact.ComputedImpactLevel;

                    setOverImpactToDisplay();
                });
        }

        function setOverImpactToDisplay() {
            if (_.isUndefined($scope.boxModel.OverallImpactLevel)) {
                $scope.ctrlCtxt.overallImpactToDisplay = 0;
                return;
            }

            $scope.ctrlCtxt.overallImpactToDisplay = $scope.boxModel.OverallImpactLevel.Order;
        }

        function init() {
            // Set initial OverallImpactLevel
            if (!$scope.boxModel.OverallImpactLevel) {
                $scope.boxModel.HasFinancialImpact = !!$scope.boxModel.HasFinancialImpact
                $scope.boxModel.HasOperationalImpact = !!$scope.boxModel.HasOperationalImpact
                $scope.boxModel.HasComplianceImpact = !!$scope.boxModel.HasComplianceImpact
                impactChanged();
            } else {
                setOverImpactToDisplay();
            }
        }
    }
})();